<div class="gw-space-y-6">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <!-- Single boolean value -->
    <ng-container *ngIf="!isObjectValue">
      <div class="gw-space-y-4">
        <p class="gw-text-text-primary gw-text-base">
          {{
            'features.settings.parameters.' + setting.key + '.description'
              | translate
          }}
        </p>
        <label class="gw-flex gw-items-center gw-gap-[8px] gw-cursor-pointer">
          <input
            type="checkbox"
            formControlName="value"
            class="gw-w-[20px] gw-h-[20px] gw-rounded-[6px] gw-cursor-pointer"
          />
          <span class="gw-text-[16px] gw-text-text-secondary">
            {{
              ('features.settings.parameters.' + setting.key + '.label'
                | translate) || setting.key
            }}
          </span>
        </label>
      </div>
    </ng-container>

    <!-- Object of booleans -->
    <ng-container *ngIf="isObjectValue">
      <div class="gw-space-y-4">
        <p class="gw-text-text-primary gw-text-base">
          {{
            'features.settings.parameters.' + setting.key + '.description'
              | translate
          }}
        </p>
        <div class="gw-space-y-3">
          <ng-container *ngFor="let key of booleanKeys">
            <label
              class="gw-flex gw-items-center gw-gap-[8px] gw-cursor-pointer"
            >
              <input
                type="checkbox"
                [formControlName]="key"
                class="gw-w-[20px] gw-h-[20px] gw-rounded-[6px] gw-cursor-pointer"
              />
              <span class="gw-text-[16px] gw-text-text-secondary">
                {{ getSettingLabel(key) || key }}
              </span>
            </label>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
